// Importamos los componentes necesarios
import {Pipe, PipeTransform} from '@angular/core';

// Le ponemos un nombre a la tuberia
@Pipe({name: 'get_id'})

// Definimos la clase implementado la interface PipeTransform
export class GetIdPipe implements PipeTransform {
  transform (notas: any, alumno): any {
    let value: any;
    notas.forEach(item => {
      if ( item.id_alumno === alumno.id) {
        value = item.id_examen;
      }
    });
    return value;
  }

}
